import { Component } from '@angular/core';

@Component({
  selector: 'app-unlock-a-pdf-file-easily',
  imports: [],
  templateUrl: './unlock-a-pdf-file-easily.component.html',
  styleUrl: './unlock-a-pdf-file-easily.component.css'
})
export class UnlockAPdfFileEasilyComponent {

}
